import React from 'react';
import "../styles/App.scss";
import "../styles/PagesStyles.scss";
import Carousel from 'react-material-ui-carousel';
import Typography from '@mui/material/Typography';
import MySlideshow from '../components/MySlideshow';

function CommissionMe(){
    
    var slideItems = [
        {
            name:"Commission Sheet slide 01",
            description: "Introduction to my commissions",
            img:"/assets/images/commisionSheet/new-page01.png"
        },
        {
            name:"Commission Sheet slide 02",
            description: "Prices to my commissions",
            img:"/assets/images/commisionSheet/new-page02-02.png"
        },
        {
            name:"Commission Sheet slide 03",
            description: "Terms to my commisions",
            img:"/assets/images/commisionSheet/new-page03.png"
        },
        {
            name:"Commission Sheet slide 04",
            description: "Payment to my commissions",
            img:"/assets/images/commisionSheet/new-page04-UPDATE.png"
        },
    ]

    const styleimgClass="Commission-img";

    return(
        <>
            <div className="Commissionpage-maincontent">
                <div className="Commission-text">
                    <Typography variant="h1">Commission Me!</Typography>
                    <Typography variant="h2">I can make art for you :D</Typography>
                    <Typography variant="body1">
                        Do you have an idea you want to bring to life?
                    
                        Are you someone with lots of ideas but can't find ways to bring those ideas into 
                        one solid concept?

                        I can help with that!
                    </Typography>
                </div>
                <div className="Commission-img-container">
                    {/*slide show goes here */}
                    <Carousel>
                        {
                            slideItems.map((item, i) =><MySlideshow key={i} item={item} imageClass={styleimgClass}/>)
                        }
                    </Carousel>
                    <div className="tape tape-commission-1"></div>
                    <div className="tape tape-commission-2"></div>
                </div>
            </div>
        </>
    );
}

// function Slideshow(props){
    
//     const [open, setOpen] =useState(false);

//     const handleClickOpen = () => {
//         setOpen(true);
//     };

//     const handleClose = () => {
//         setOpen(false);
//     };

//     return(
//         <Paper>
//             {/*  */}
//             <Button onClick={handleClickOpen}>
//                 <img className={props.imageClass} src={props.item.img} alt={props.item.description}/>
//             </Button>

//             <MyModal
//                 open={open}
//                 onClose={handleClose}
//                 img = {props.item.img}
//                 description = {props.item.description}
//             />
//         </Paper>
//     )
// }

export default CommissionMe;